import MaterialIcon from '@/components/atom/MaterialIcon';
import theme from '@/styles/theme';

const MagazineListByAuthorEmpty = () => {
  return (
    <div className={'flex h-[480px] items-center justify-center'}>
      <div className={'flex flex-col items-center gap-[15px]'}>
        <MaterialIcon name={'upcoming'} size={48} color={theme.color.gray100} filled />
        <div className={'typography-ui-20sb text-gray-600'}>작성된 콘텐츠가 없어요</div>
      </div>
    </div>
  );
};

export default MagazineListByAuthorEmpty;
